import React from "react";

function BS4_GridBasic() {
  return (
    <div>
      <h1>BS4_GridBasic Component</h1>
      <p>This is the BS4_GridBasic tutorial page content.</p>
    </div>
  );
}

export default BS4_GridBasic;
